import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { TextFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const PermittedUseFilter: ISourcingToolSearchFilter = {
  id: "permitted-use-id",
  type: "text",
  field: "sidebar.react.search_sidebar.permitted_use",
  text: "",
  must: TextFilterMust.CONTAIN,
  mustOptions: [TextFilterMust.CONTAIN, TextFilterMust.NOT_CONTAIN],
  updateFilterDialogIsVisible: false,
  searchTypes: [SearchType.SOURCING_TOOL_US_FL],
};
